import classNames from 'classnames';
import { ReactNode } from 'react';

import { DEFAULT_LANDING_PAGE_ACCENT_COLOR } from '@consts';
import { setupForDark } from '@theme';
import * as _ from 'lodash';

interface RoundButtonProps extends React.HTMLAttributes<HTMLElement> {
  onClick: any;
  children: ReactNode;
  type: 'primary' | 'color' | 'empty';
  size: 'small' | 'medium' | 'large' | 'xlarge';
  color?: string;
  disabled?: boolean;
  className?: string;
}

export default function RoundButton({
  disabled = false,
  onClick,
  children,
  type = 'primary',
  size = 'medium',
  color = DEFAULT_LANDING_PAGE_ACCENT_COLOR,
  className = '',
  style,
  ...rest
}: RoundButtonProps) {
  return (
    <div
      {...rest}
      // The root is a div, so `disabled` leaves no mark in the DOM -- it only swaps
      // the handler for a noop. aria-disabled is what a screen reader (and a test
      // waiting to click) can actually read.
      aria-disabled={disabled}
      onClick={disabled ? _.noop : onClick}
      className={classNames(
        size === 'small' && 'P3M px-sm py-xxs',
        size === 'medium' && 'P1M px-lg py-xs',
        size === 'large' && 'P1B px-xl py-md',
        size === 'xlarge' && 'H5 px-xl py-sm',
        'rounded-full',
        'text-center',
        'box-sizing-border',
        'border-[2px]',
        !disabled && 'cursor-pointer',
        !disabled && 'hover:delay-100',
        !disabled && 'hover:scale-105 transition-all duration-300',
        type === 'primary' && setupForDark('bg-button1 text-button1 border-bg-button1'),
        type === 'color' && setupForDark('text-white'),
        type === 'empty' && setupForDark('text-primary border-white'),
        className
      )}
      style={{
        backgroundColor: type === 'color' ? color : undefined,
        borderColor: type === 'color' ? color : undefined,
        ...style
      }}
    >
      {children}
    </div>
  );
}
